import React from 'react'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'
import Subtitle from '../../atoms/Subtitle'
import CheckCircleSymbol from '../../atoms/CheckCircleSymbol'
import LogoTitle from '../../molecules/LogoTitle'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const CheckCircleWrapper = styled(View)`
  margin-top: 24px;
`

const Description = styled(Subtitle)`
  margin-top: 16px;
`

export default () => (
  <Content>
    <LogoTitle title="Senha alterada com sucesso" />
    <CheckCircleWrapper>
      <CheckCircleSymbol />
    </CheckCircleWrapper>
    <Description>Lembre-se: não salve senhas em computadores ou aparelhos públicos.</Description>
    <Description>Renove suas senhas periodicamente, mas não repita senhas antigas.</Description>
  </Content>
)
